import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingFullscreenService {
  constructor() {}

  private loadingCount$ = signal<number>(0);
  loading$ = computed(() => this.loadingCount$() > 0);

  show() {
    this.loadingCount$.update((count) => count + 1);
  }

  hide() {
    if (this.loadingCount$() == 0) return;

    this.loadingCount$.update((count) => count - 1);
  }

  reset() {
    this.loadingCount$.set(0);
  }
}
